export const AuthStyleSteps0 = [{
		title: '上传企业营业执照',
		content: '上传企业营业执照照片，或加盖公章的企业营业执照复印件。',
		active_icon: '',
		inactive_icon: '',
	}, {
		title: '上传法人身份证照片',
		content: '上传法人身份证/护照照片，或加盖公章的身份证/护照复印件。',
		active_icon: '',
		inactive_icon: '',
	}, {
		title: '上传办理人身份证照片',
		content: '上传办理人份证照片，或加盖公章的身份证复印件。如果您是法人，可在企业实名认证方式中直接选择法人认证方式进行企业认证。',
		active_icon: '',
		inactive_icon: '',
	}, {
		title: '上传申请授权书',
		content: '上传加盖公章的申请授权书',
		active_icon: '',
		inactive_icon: '',
	},
	{
		title: '创建电子印章',
		content: '上传印模图片或通过系统自动生成创建电子印章。',
	}, {
		title: '进行打款',
		content: '可选择平台向企业打款，或企业向平台打款进行企业认证。',
		active_icon: '',
		inactive_icon: '',
	}, {
		title: '系统验证，完成认证',
		content: '- 平台向企业打款，企业回填平台打款的具体金额。\r\n- 企业向平台打款，平台验证企业打款。\r\n \r\n平台同时审核企业递交的材料，全部通过后，完成认证。',
		active_icon: '',
		inactive_icon: '',
	}
];

export const AuthStyleSteps1 = [{
	title: '上传企业营业执照',
	content: '上传企业营业执照照片，或加盖公章的企业营业执照复印件。',
	active_icon: '',
	inactive_icon: '',
}, {
	title: '上传法人身份证照片',
	content: '上传法人身份证/护照照片，或加盖公章的身份证/护照复印件。',
	active_icon: '',
	inactive_icon: '',
}, {
	title: '法人实人认证',
	content: '法人通过人脸识别进行法人身份认证。',
	active_icon: '',
	inactive_icon: '',
}, {
	title: '创建电子印章',
	content: '上传印模图片或通过系统自动生成创建电子印章。',
}, {
	title: '进行打款',
	content: '可选择平台向企业打款，或企业向平台打款进行企业认证。',
	active_icon: '',
	inactive_icon: '',
}, {
	title: '系统验证，完成认证',
	content: '- 平台向企业打款，企业回填平台打款的具体金额。\r\n- 企业向平台打款，平台验证企业打款。\r\n \r\n平台同时审核企业递交的材料，全部通过后，完成认证。',
	active_icon: '',
	inactive_icon: '',
}];